import axios from "axios";

const api = axios.create({
  baseURL: "https://qa2d0e2r46.execute-api.us-west-2.amazonaws.com/default",
});

export default api;
